export default "__VITE_ASSET__B_IOO6DV__"